import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

const useComponentInstancesApi = () => {
  const listEquipos = useCallback(async (tenantId) => {
    const { data } = await axios.get(`${API_PATH}/liftlogic/tenants/${tenantId}/ascensores`, {
      headers: authHeaders(),
    });
    return data; // { rows: [...] }
  }, []);

  const getTree = useCallback(async (tenantId, equipoId) => {
    const { data } = await axios.get(
      `${API_PATH}/liftlogic/ascensores/${equipoId}/components?tenantId=${tenantId}`,
      { headers: authHeaders() }
    );
    return data; // { tree }
  }, []);

  const addNode = useCallback(async (tenantId, equipoId, payload) => {
    const { data } = await axios.post(
      `${API_PATH}/liftlogic/ascensores/${equipoId}/components?tenantId=${tenantId}`,
      payload,
      { headers: authHeaders() }
    );
    return data;
  }, []);

  const updateNode = useCallback(async (tenantId, nodeId, payload) => {
    const { data } = await axios.put(
      `${API_PATH}/liftlogic/components/${nodeId}?tenantId=${tenantId}`,
      payload,
      { headers: authHeaders() }
    );
    return data;
  }, []);

  const removeNode = useCallback(async (tenantId, nodeId) => {
    const { data } = await axios.delete(
      `${API_PATH}/liftlogic/components/${nodeId}?tenantId=${tenantId}`,
      { headers: authHeaders() }
    );
    return data;
  }, []);

  const cloneTemplate = useCallback(async (tenantId, equipoId, rootId) => {
    const { data } = await axios.post(
      `${API_PATH}/liftlogic/ascensores/${equipoId}/components/clone-template/${rootId}?tenantId=${tenantId}`,
      {},
      { headers: authHeaders() }
    );
    return data;
  }, []);

  const replaceComponent = useCallback(async (tenantId, equipoId, nodeId, payload) => {
    const { data } = await axios.post(
      `${API_PATH}/liftlogic/ascensores/${equipoId}/components/${nodeId}/replace?tenantId=${tenantId}`,
      payload,
      { headers: authHeaders() }
    );
    return data;
  }, []);

  const listReplacements = useCallback(async (tenantId, equipoId, nodeId) => {
    const { data } = await axios.get(
      `${API_PATH}/liftlogic/ascensores/${equipoId}/components/${nodeId}/replacements?tenantId=${tenantId}`,
      { headers: authHeaders() }
    );
    return data; // { replacements }
  }, []);

  return useMemo(
    () => ({
      listEquipos,
      getTree,
      addNode,
      updateNode,
      removeNode,
      cloneTemplate,
      replaceComponent,
      listReplacements,
    }),
    [
      listEquipos,
      getTree,
      addNode,
      updateNode,
      removeNode,
      cloneTemplate,
      replaceComponent,
      listReplacements,
    ]
  );
};

export default useComponentInstancesApi;
